import { defineStore } from 'pinia';
import apiService, { type HealthReport } from '@/services/api';

export const useHealthStore = defineStore('health', {
  state: () => ({
    report: null as HealthReport | null
  }),
  getters: {
    overallStatus: (state) => state.report?.status ?? 'Unknown'
  },
  actions: {
    async fetchReport() {
      const res = await apiService.getHealth();
      if (res.success && res.data) {
        this.report = res.data;
      }
    }
  }
});
